import { render, staticRenderFns } from "./FooterBlock.vue?vue&type=template&id=4ce00a19&scoped=true&"
import script from "./FooterBlock.vue?vue&type=script&lang=js&"
export * from "./FooterBlock.vue?vue&type=script&lang=js&"
import style0 from "./FooterBlock.vue?vue&type=style&index=0&id=4ce00a19&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce00a19",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ce00a19')) {
      api.createRecord('4ce00a19', component.options)
    } else {
      api.reload('4ce00a19', component.options)
    }
    module.hot.accept("./FooterBlock.vue?vue&type=template&id=4ce00a19&scoped=true&", function () {
      api.rerender('4ce00a19', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/blocks/FooterBlock.vue"
export default component.exports